import { useParams } from "react-router-dom";
import { OfflineShips } from "../../DataStore/Ships/OfflineShips";
import NotFound from "../404";
import styles from "./styles.module.scss";
import { Container, Row } from "react-bootstrap";
import { ShipHeader } from "./ShipHeader";
import { Button } from "antd";
import { OfflineShipModal } from "../../Components/Modals/OfflineShipModal";
import { useState } from "react";

const Ship = () => {

  const { shipName } = useParams();

  const shipDetails = OfflineShips.filter(ship => ship.shipSlug === shipName);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    shipDetails?.length ?
      <div>
        <div
          className="mb-32"
          style={{ position: "relative" }}
        >
          <img
            src={shipDetails[0]?.banner}
            className={styles.ShipImageLarge}
            alt="ship"
          />
        </div>
        <div className="column-padding-b">
          <Container>
            <div className="mb-32">
              <ShipHeader shipDetails={shipDetails[0]} />

              <Row className="mb-32">
                <div className="flex full-height flex-row">
                  <h2 className="font-regular para font-para-black opacity-80 justified m-0 flex center">
                    {shipDetails[0]?.overview}
                  </h2>
                </div>
              </Row>
              <div className="flex center">
                <Button
                  type="primary"
                  size="large"
                  className="btn-small btn-primary card-button font-regular font-white"
                  onClick={() => {
                    showModal();
                  }}
                  rel="noopener noreferrer"
                  aria-label="Book Now Button"
                >

                  {`Enquire About ${shipDetails[0]?.shipname}`}
                </Button>
              </div>

            </div>
            <OfflineShipModal
              shipDetails={shipDetails[0]}
              isModalOpen={isModalOpen}
              handleOk={handleOk}
              handleCancel={handleCancel}
            />
          </Container>
        </div>
      </div> : <NotFound />
  )
}

export default Ship;